<div class="animated animate-pulse duration-100">
  <p class="h-4 w-64 rounded bg-gray-900 animate-pulse"></p>
</div>
